var map = {
	"./code-flow-template.ts": [
		30226,
		226
	],
	"./decision-flow-template.ts": [
		51530,
		1530
	],
	"./default-template.ts": [
		40094
	],
	"./flowchart-template.ts": [
		11208,
		1208
	],
	"./knowledge-graph-template.ts": [
		54878,
		4878
	],
	"./mindmap-dark-template.ts": [
		3494,
		3494
	],
	"./mindmap-template.ts": [
		44719,
		4719
	],
	"./network-diagram-dark-template.ts": [
		37135,
		7135
	],
	"./network-diagram-icons-template.ts": [
		73053,
		3053
	],
	"./org-chart-template.ts": [
		96785,
		6785
	],
	"./pert-light-template.ts": [
		61000,
		1000
	],
	"./playful-mindmap-template.ts": [
		26227,
		6227
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 97065;
module.exports = webpackAsyncContext;